import {createFileRoute} from '@tanstack/react-router'
import {thirdLevelLayoutRoute} from "../../../../../../../utils/collectionListing";

export const Route = createFileRoute('/_site/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName')({
    ...thirdLevelLayoutRoute()
});
